import React, { useState } from "react";
import { getDatabase, ref, set } from "firebase/database";
import { getAuth } from "firebase/auth";

function AlertPage() {
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  

  const sendAlert = (type) => {
    const confirmed = window.confirm(`คุณแน่ใจหรือไม่ว่าต้องการส่งแจ้งเตือน "${type}" ?`);
    if (!confirmed) return;
  
    const db = getDatabase();
    const auth = getAuth();
    const user = auth.currentUser;
  
    if (!user) {
      setMessage("กรุณา Login ก่อนส่งแจ้งเตือน");
      setStatus("danger");
      return;
    }
  
    const alertData = {
      type: type,
      sender_uid: user.uid,
      time_utc: new Date().toISOString(),
    };
  
    set(ref(db, "manual_alert"), alertData)
      .then(() => {
        setMessage(`ส่งแจ้งเตือน "${type}" สำเร็จเรียบร้อยแล้ว`);
        setStatus("success");
      })
      .catch((err) => {
        setMessage("เกิดข้อผิดพลาดในการส่งแจ้งเตือน");
        setStatus("danger");
      });
  };
  
  return (
    <div   style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100vh - 60px)", // ลบความสูงของ navbar ออก
      }} >
      <div className="card shadow-lg">
        <div className="card-body text-center">
          <h4 className="card-title mb-4">
            🛑 ส่งแจ้งเตือนฉุกเฉิน
          </h4>

          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <button
              className="btn btn-danger btn-lg"
              onClick={() => sendAlert("ไฟไม้อาคาร")}
            >
              🚒 ไฟไม้อาคาร
            </button>
            <button
              className="btn btn-warning btn-lg"
              onClick={() => sendAlert("อพยพด่วน")}
            >
              🏃‍♂️ อพยพด่วน
            </button>
            <button
              className="btn btn-secondary btn-lg"
              onClick={() => sendAlert("ขอความช่วยเหลือ")}
            >
              🛑 ขอความช่วยเหลือ
            </button>
          </div>

          {message && <div className="alert alert-success mt-4">{message}</div>}
          {status && <div className="text-danger mt-3">{status}</div>}
        </div>
      </div>
    </div>
  );
}

export default AlertPage;
